import React, { useState } from 'react';
import './companySideFilter.css';

const MAX_VISIBLE_OPTIONS = 5;

const CompanySideFilter = ({ filters, onFilterChange, selectedFilters }) => {
  const [expandedFilters, setExpandedFilters] = useState({}); 

  const handleFilterChange = (filterName, option) => {
    
    const updatedFilters = {
      ...selectedFilters,
      [filterName]: selectedFilters[filterName] === option ? null : option,
    };
    
    onFilterChange(updatedFilters);
  };

  const toggleFilterExpansion = (filterName) => {
    setExpandedFilters((prev) => ({
      ...prev,
      [filterName]: !prev[filterName], 
    }));
  };

  return (
    <div className="company-side-filter__container">
      {filters.map((filter) => {
        const isExpanded = expandedFilters[filter.name];
        const visibleOptions = isExpanded
          ? filter.options
          : filter.options.slice(0, MAX_VISIBLE_OPTIONS);

        return (
          <div key={filter.name} className="company-side-filter__item">
            <label htmlFor={filter.name}>{filter.label}</label>
            <div className="company-side-filter__list-container">
              {visibleOptions.map((option) => (
                <button
                  key={option}
                  className={selectedFilters[filter.name] === option ? 'active-filter' : ''}
                  onClick={() => {
                    handleFilterChange(filter.name, option);
                  }}
                >
                  <span className="company-side-filter__option">{option}</span>
                </button>
              ))}
            </div>
            {filter.options.length > MAX_VISIBLE_OPTIONS && (
              <button
                className="company-side-filter__toggle"
                onClick={() => toggleFilterExpansion(filter.name)}
              >
                {isExpanded ? 'Mostrar menos' : 'Mostrar más'}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CompanySideFilter;
